"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tableHeader = void 0;

var _util = require("../../../util");

const tableHeader = ({
  cssProps,
  theme
}) => {
  const {
    divider,
    dividerPartial
  } = cssProps;
  return {
    display: 'table-header-group',
    '& > tr': {
      boxShadow: divider ? (0, _util.boxShadow)(theme, [0, -1, 0, 'ui4', true]) : undefined,
      '& > th:not(:last-child):not(:first-child)': {
        boxShadow: dividerPartial ? (0, _util.boxShadow)(theme, [0, -1, 0, 'ui4', true]) : undefined
      }
    }
  };
};

exports.tableHeader = tableHeader;
//# sourceMappingURL=TableHead.style.js.map